import React, { useEffect, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import TransactionsHistory from './Transactions/TransactionHistory';
import SummaryCards from './Transactions/SummaryCards';
import WithdrawFundsCard from './Transactions/WithdrawCard';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageLoader from '../../../Reusable/PageLoader'; 
import baseURL from '../../user/config';

const Transactions = () => {
    const [summaryData, setSummaryData] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
             //   await new Promise(resolve => setTimeout(resolve, 4000));

            // Fetch summary and transactions concurrently
            const [summaryResponse, transactionsResponse] = await Promise.all([
                fetch(`${baseURL}/org/transactions/summary`, { credentials: 'include' }),
                fetch(`${baseURL}/org/transactions`, { credentials: 'include' })
            ]);

            const [summaryDataResult, transactionsDataResult] = await Promise.all([
                summaryResponse.json(),
                transactionsResponse.json()
            ]);

            if (!summaryResponse.ok) throw new Error(summaryDataResult.message || 'Failed to fetch summary data.');
            if (!transactionsResponse.ok) throw new Error(transactionsDataResult.message || 'Failed to fetch transactions.');

            setSummaryData(summaryDataResult);
            setTransactions(transactionsDataResult);
        } catch (err) {
            toast.error(err.message || 'Failed to load transactions');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <DashboardLayout>
            {isLoading && <PageLoader />} {/* <-- loader inside layout */}

            {!isLoading && (
                <Box sx={{ p: 3 }}>
                    <SummaryCards summaryData={summaryData} />
                    <TransactionsHistory transactions={transactions} />
                    <WithdrawFundsCard summaryData={summaryData} onWithdrawSuccess={fetchData} />
                </Box>
            )}
        </DashboardLayout>
    );
};

export default Transactions;
